import { Link } from "react-router-dom";

export const Logo = ({ height = 56, heightClass, onDark = true, "data-testid": testId }) => {
  const src = onDark ? "/logo-ondark.png" : "/logo-onlight.png";
  return (
    <Link
      to="/"
      data-testid={testId}
      className="inline-flex items-center"
      aria-label="AIM High home"
    >
      <img
        src={src}
        alt="AIM High"
        className={heightClass ? `${heightClass} w-auto block` : undefined}
        style={heightClass ? undefined : { height: `${height}px`, width: "auto", display: "block" }}
      />
    </Link>
  );
};
